import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';

export const collectUnstartedMediaAnalysisFileIds = (files: TFileWithMeta[]): string[] =>
  files
    .filter(
      (file) =>
        file.meta.status !== 'removed' &&
        file.meta.extra?.analysisStatus === 'progress' &&
        Boolean(file.meta.extra?.mediaId) &&
        !file.meta.extra?.analysisStartedAt,
    )
    .map((file) => file.meta.id);
